module.exports = __webpack_public_path__ + "img/439.9a468c26.png";